<template>
  <div id="add_timesheet" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Add Time Card</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="impaddtimessheetclose"
            @click="clickCloseModel"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <Form @submit="onSubmit">
            <!-- Date & Employee Info -->
            <div class="input-block mb-3">
              <datepicker
                v-model="addstartdate"
                placeholder="Choose Date"
                class="form-control floating datetimepicker"
                :editable="true"
                :clearable="false"
                :input-format="dateFormat"
              />
            </div>
            <div class="input-block mb-3">
              <Field
                name="user_id"
                as="select"
                class="form-control"
                v-model="addform.user_id"
                :class="{ 'is-invalid': clientError.includes('user_id') }"
                @change="handleChangeEvent('user_id')"
              >
                <option value="">Select Employee</option>
                <option
                  v-for="employee in employee_list2"
                  :key="employee.id"
                  :value="employee.id"
                >
                  {{ employee.first_name }} {{ employee.last_name }}
                </option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('user_id')"
              >
                Employee is required
              </div>
            </div>

            <div class="input-block mb-3">
              <Field
                name="designation_id"
                as="select"
                class="form-control"
                v-model="addform.designation_id"
                :class="{
                  'is-invalid': clientError.includes('designation_id'),
                }"
                @change="handleChangeEvent('designation_id')"
              >
                <option value="">Select Position</option>
                <option
                  v-for="employee in designation_list2"
                  :key="employee.id"
                  :value="employee.id"
                >
                  {{ employee.name }}
                </option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('designation_id')"
              >
                Position is required
              </div>
            </div>

            <div class="input-block mb-3">
              <Field
                name="punch_from"
                as="select"
                class="form-control"
                v-model="addform.punch_from"
                :class="{ 'is-invalid': clientError.includes('punch_from') }"
                @change="handleChangeEvent('punch_from')"
              >
                <option value="">Select Punch From</option>
                <option value="1">Office</option>
                <option value="2">Home</option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('punch_from')"
              >
                Punch from is required
              </div>
            </div>

            <!-- Worked Time -->
            <b-card class="mb-3">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">
                  <i class="fas fa-clock me-2"></i>
                  Worked
                  <small class="text-muted"
                    >({{ convertHoursToTimeFormat(addWorkedHours) }})</small
                  >
                </h6>
              </div>

              <b-row class="mb-2">
                <b-col cols="6">
                  <label>Clocked in</label>
                  <div class="input-group time">
                    <!-- <a-time-picker
                      v-model:value="addform.punch_in_time"
                      format="hh:mm A"
                      value-format="HH:mm"
                      use12-hours
                      class="form-control timepicker"
                      placeholder="hh:mm AM/PM"
                    /> -->
                    <a-date-picker
                      v-model:value="addform.punch_in_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label>Clocked out</label>
                  <div class="input-group time">
                    <!-- <a-time-picker
                      v-model:value="addform.punch_out_time"
                      format="hh:mm A"
                      value-format="HH:mm"
                      use12-hours
                      class="form-control timepicker"
                      placeholder="hh:mm AM/PM"
                    /> -->
                    <a-date-picker
                      v-model:value="addform.punch_out_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
              </b-row>
            </b-card>

            <!-- Breaks Section -->
            <b-card>
              <h6 class="mb-3">
                <i class="fas fa-mug-hot me-2"></i>
                Breaks
              </h6>

              <!-- Paid Break -->
              <label class="fw-bold">Total paid break time</label>
              <div v-if="addform?.list_breaks?.breaks?.length">
                <b-input-group
                  class="mb-2"
                  v-for="(entry, index) in addform.list_breaks.breaks"
                  :key="index"
                >
                  <b-row class="mb-2 align-items-center">
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_out_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_out_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_in_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_in_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="2" class="text-center">
                      <i
                        class="fa fa-trash"
                        style="cursor: pointer; color: red; font-size: 18px"
                        @click="removeNewBreak(index)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-input-group>
              </div>
              <div class="mt-2 mb-3">
                <b-button
                  variant="link"
                  class="p-0 text-primary text-decoration-none"
                  @click="addNewBreak"
                >
                  <i class="fa fa-plus me-1"></i> Add a break
                </b-button>
              </div>

              <!-- Unpaid Break -->
              <label class="fw-bold">Total unpaid break time</label>
              <div v-if="addform?.list_unpaid_breaks?.breaks?.length">
                <b-input-group
                  class="mb-2"
                  v-for="(entry, index) in addform.list_unpaid_breaks.breaks"
                  :key="'unpaid-' + index"
                >
                  <b-row class="mb-2 align-items-center">
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_out_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_out_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_in_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_in_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="2" class="text-center">
                      <i
                        class="fa fa-trash"
                        style="cursor: pointer; color: red; font-size: 18px"
                        @click="removeNewUnpaidBreak(index)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-input-group>
              </div>

              <!-- Add Unpaid Break Button on new line -->
              <div class="mt-2">
                <b-button
                  variant="link"
                  class="p-0 text-primary text-decoration-none"
                  @click="addNewUnpaidBreak"
                >
                  <i class="fa fa-plus me-1"></i> Add a break
                </b-button>
              </div>
            </b-card>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>

  <div id="edit_timesheet" class="modal custom-modal fade" role="dialog">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Timesheet Details</h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            ref="imptimessheetclose"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div
            class="alert alert-warning"
            v-if="
              selectedtimesheet.attendance?.firstpunch.checkintime &&
              !selectedtimesheet.attendance?.lastpunch.checkouttime
            "
          >
            <i class="fa fa-exclamation-triangle me-2"></i>
            Missing Clock-Out
          </div>
          <Form @submit="onUpdate">
            <!-- Date & Employee Info -->
            <i
              class="fa fa-trash"
              style="cursor: pointer; color: red; float: right"
              @click="
                deleteTimesheet(
                  Number(
                    selectedtimesheet.attendance?.employee_attendance_id
                  ) || 0
                )
              "
            ></i>
            <p class="text-muted mb-1">{{ form.date }}</p>
            <h5>
              <strong>
                {{ form.employee_name }}
              </strong>
            </h5>

            <!-- Role & Location -->

            <b-form-group class="mb-3 d-flex align-items-center">
              <b-form-select
                class="me-2"
                :options="
                  designation_list2
                    ? designation_list2.map((item) => ({
                        value: item.id,
                        text: item.name,
                      }))
                    : []
                "
                v-model="form.selected_designation"
              ></b-form-select>
              <span class="text-muted">at {{ form?.office_name || "" }}</span>
            </b-form-group>

            <div class="input-block mb-3">
              <label class="col-form-label"
                >Punch From <span class="text-danger">*</span></label
              >
              <Field
                name="edit_punch_from"
                as="select"
                class="form-control"
                v-model="form.punch_from"
                :class="{
                  'is-invalid': clientError.includes('edit_punch_from'),
                }"
                @change="handleChangeEvent('edit_punch_from')"
              >
                <option value="">Select Punch From</option>
                <option value="1">Office</option>
                <option value="2">Home</option>
              </Field>
              <div
                class="invalid-feedback"
                v-if="clientError.includes('edit_punch_from')"
              >
                Punch from is required
              </div>
            </div>

            <!-- Worked Time -->
            <b-card class="mb-3">
              <div
                class="d-flex justify-content-between align-items-center mb-2"
              >
                <h6 class="mb-0">
                  <i class="fas fa-clock me-2"></i>
                  Worked
                  <small class="text-muted"
                    >({{
                      convertHoursToTimeFormat(
                        workedHours ||
                          selectedtimesheet?.attendance?.total_hours
                      )
                    }})</small
                  >
                </h6>
              </div>

              <b-row class="mb-2">
                <b-col cols="6">
                  <label
                    >Clocked in
                    {{
                      selectedtimesheet.attendance?.firstpunch.checkintime ||
                      form.punch_in_time
                        ? `(${
                            selectedtimesheet.attendance?.firstpunch
                              .converted_checkintime || form.punch_in_time
                          })`
                        : ""
                    }}</label
                  >
                  <div class="input-group time">
                    <!-- <a-time-picker
                      v-model:value="form.punch_in_time"
                      format="hh:mm A"
                      value-format="HH:mm"
                      use12-hours
                      class="form-control timepicker"
                      placeholder="hh:mm AM/PM"
                    /> -->
                    <a-date-picker
                      v-model:value="form.punch_in_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
                <b-col cols="6">
                  <label
                    >Clocked out
                    {{
                      selectedtimesheet.attendance?.lastpunch.checkouttime ||
                      form.punch_out_time
                        ? `(${
                            selectedtimesheet.attendance?.lastpunch
                              .converted_checkouttime || form.punch_out_time
                          })`
                        : ""
                    }}</label
                  >
                  <div class="input-group time">
                    <!-- <a-time-picker
                      v-model:value="form.punch_out_time"
                      format="hh:mm A"
                      value-format="HH:mm"
                      use12-hours
                      class="form-control timepicker"
                      placeholder="hh:mm AM/PM"
                    /> -->
                    <a-date-picker
                      v-model:value="form.punch_out_time"
                      format="YYYY-MM-DD hh:mm A"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      show-time
                      use12-hours
                      placeholder="Select date and time"
                      class="form-control datetimepicker"
                    />
                    <span class="input-group-text"
                      ><i class="fa-regular fa-clock"></i
                    ></span>
                  </div>
                </b-col>
              </b-row>

              <p class="mb-0 text-muted">
                <div v-if="selectedtimesheet.shift"> 
                  Scheduled: {{ formatTimeRange(form.schedule_start_time, form.schedule_end_time) }}
                </div>
                <div v-else>
                  Scheduled: -
                </div>
              </p>
            </b-card>

            <!-- Breaks Section -->
            <b-card>
              <h6 class="mb-3">
                <i class="fas fa-mug-hot me-2"></i>
                Breaks ({{
                  selectedtimesheet?.list_breaks?.paid_breaks?.length +
                    selectedtimesheet?.list_breaks?.unpaid_breaks?.length ||
                  "0"
                }})
              </h6>

              <!-- Paid Break -->
              <label class="fw-bold">Total paid break time</label>
              <div v-if="selectedtimesheet?.list_breaks?.paid_breaks?.length">
                <b-input-group
                  class="mb-2"
                  v-for="(entry, index) in selectedtimesheet.list_breaks
                    .paid_breaks"
                  :key="index"
                >
                  <b-row class="mb-2 align-items-center">
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_out_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_out_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_in_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_in_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="2" class="text-center">
                      <i
                        class="fa fa-trash"
                        style="cursor: pointer; color: red; font-size: 18px"
                        @click="removeBreak(index)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-input-group>
              </div>
              <div class="mt-2 mb-3">
                <b-button
                  variant="link"
                  class="p-0 text-primary text-decoration-none"
                  @click="addBreak"
                >
                  <i class="fa fa-plus me-1"></i> Add a break
                </b-button>
              </div>

              <!-- Unpaid Break -->
              <label class="fw-bold">Total unpaid break time</label>
              <div v-if="selectedtimesheet?.list_breaks?.unpaid_breaks?.length">
                <b-input-group
                  class="mb-2"
                  v-for="(entry, index) in selectedtimesheet.list_breaks
                    .unpaid_breaks"
                  :key="index"
                >
                  <b-row class="mb-2 align-items-center">
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_out_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_out_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="5">
                      <div class="input-group time">
                        <!-- <a-time-picker
                          v-model:value="entry.punch_in_time_str"
                          format="hh:mm A"
                          value-format="HH:mm"
                          use12-hours
                          class="form-control timepicker"
                          placeholder="hh:mm AM/PM"
                        /> -->
                        <a-date-picker
                          v-model:value="entry.punch_in_time_str"
                          format="YYYY-MM-DD hh:mm A"
                          value-format="YYYY-MM-DD HH:mm:ss"
                          show-time
                          use12-hours
                          placeholder="Select date and time"
                          class="form-control datetimepicker"
                        />
                        <span class="input-group-text"
                          ><i class="fa-regular fa-clock"></i
                        ></span>
                      </div>
                    </b-col>
                    <b-col cols="2" class="text-center">
                      <i
                        class="fa fa-trash"
                        style="cursor: pointer; color: red; font-size: 18px"
                        @click="removeUnpaidBreak(index)"
                      ></i>
                    </b-col>
                  </b-row>
                </b-input-group>
              </div>
              <div class="mt-2 mb-3">
                <b-button
                  variant="link"
                  class="p-0 text-primary text-decoration-none"
                  @click="addUnpaidBreak"
                >
                  <i class="fa fa-plus me-1"></i> Add a break
                </b-button>
              </div>
            </b-card>
            <div class="submit-section">
              <button class="btn btn-primary submit-btn">Save</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import moment from "moment";
import { Form, Field } from "vee-validate";
import * as Yup from "yup";
import axios from "axios";
import { notification } from "ant-design-vue";

import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

const currentDate = ref(new Date(moment()));

export default {
  components: {
    Form,
    Field,
  },
  props: {
    form: [Array, Object],
    selectedtimesheet: [Array, Object],
    formErrors: [Array, Object],
    UserId: {
      type: [String, Number],
      default: "",
    },
    DesignationId: {
      type: [String, Number],
      default: "",
    },
  },
  emits: ["reload-data"],
  data() {
    return {
      addform: {
        user_id: "",
        designation_id: "",
        punch_from: "",
        punch_in_time: "",
        punch_out_time: "",
      },
      employee_list2: [],
      designation_list2: [],
      clientError: [],
      addstartdate: currentDate,
      dateFormat: "MMM dd, yyyy",
    };
  },
  methods: {
    handleChangeEvent(target) {
      this.clientError = this.clientError.filter((item) => item !== target);
    },
    loadAllEmployees() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/employees/allemployees")
        .then((response) => {
          this.employee_list2 = response.data.data;

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    loadDesignations() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      axios
        .get("/designations/all")
        .then((response) => {
          this.designation_list2 = response.data.data;

          loader.hide();
        })
        .catch((error) => {
          loader.hide();

          var response = error.response;

          if (
            error.response.status == 401 &&
            response.data.message == "Unauthenticated."
          ) {
            localStorage.clear();

            notification.open({
              message: "Please Login",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });

            this.$router.push({ name: "login" }).catch((error) => {});
          } else {
            this.errorMessage = error.message;
            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    onSubmit() {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();

      if (!this.addform.user_id == "") {
        postform.append("user_id", this.addform.user_id);
      } else {
        this.clientError.push("user_id");
      }

      if (!this.addform.designation_id == "") {
        postform.append("designation_id", this.addform.designation_id);
      } else {
        this.clientError.push("designation_id");
      }

      if (!this.addform.punch_from == "") {
        postform.append("punch_from", this.addform.punch_from);
      } else {
        this.clientError.push("punch_from");
      }

      if (this.clientError?.length) {
        loader.hide();
        return;
      }

      postform.append(
        "timesheet_date",
        moment(this.addstartdate).format("YYYY-MM-DD")
      );

      if (this.addform.punch_in_time != "") {
        // const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
        // const timePart = this.addform.punch_in_time;
        // const fullDateTime = moment(
        //   `${datePart} ${timePart}`,
        //   "YYYY-MM-DD HH:mm"
        // ).format("YYYY-MM-DD HH:mm:ss");
        // postform.append("clocked_in", fullDateTime);

        postform.append("clocked_in", this.addform.punch_in_time);
      } else {
        postform.append("clocked_in", "");
      }

      if (this.addform.punch_out_time != "") {
        // const datePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
        // const timePart2 = this.addform.punch_out_time;
        // const fullDateTime2 = moment(
        //   `${datePart} ${timePart2}`,
        //   "YYYY-MM-DD HH:mm"
        // ).format("YYYY-MM-DD HH:mm:ss");
        // postform.append("clocked_out", fullDateTime2);

        postform.append("clocked_out", this.addform.punch_out_time);
      } else {
        postform.append("clocked_out", "");
      }

      if (this.addform?.list_breaks?.breaks?.length) {
        this.addform.list_breaks.breaks.forEach((brk, index) => {
          //console.log(brk);

          // var bdatePart = moment(this.addstartdate).format("YYYY-MM-DD"); // → "2025-06-25"
          // var btimePart = brk.punch_out_time_str;
          // var bfullDateTime = moment(
          //   `${bdatePart} ${btimePart}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");

          // postform.append(
          //   `paid_breaks[${index}][clocked_out_datetime]`,
          //   bfullDateTime
          // );

          postform.append(
            `paid_breaks[${index}][clocked_out_datetime]`,
            brk.punch_out_time_str
          );

          // var btimePart2 = brk.punch_in_time_str;
          // var bfullDateTime2 = moment(
          //   `${bdatePart} ${btimePart2}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");

          // postform.append(
          //   `paid_breaks[${index}][clocked_in_datetime]`,
          //   bfullDateTime2
          // );

          postform.append(
            `paid_breaks[${index}][clocked_in_datetime]`,
            brk.punch_in_time_str
          );
        });
      } else {
        postform.append("paid_breaks", []);
      }

      if (this.addform?.list_unpaid_breaks?.breaks?.length) {
        this.addform.list_unpaid_breaks.breaks.forEach((brk, index) => {
          // const datePart = moment(this.addstartdate).format("YYYY-MM-DD");

          // const outTime = moment(
          //   `${datePart} ${brk.punch_out_time_str}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");
          // postform.append(
          //   `unpaid_breaks[${index}][clocked_out_datetime]`,
          //   outTime
          // );

          postform.append(
            `unpaid_breaks[${index}][clocked_out_datetime]`,
            brk.punch_out_time_str
          );

          // const inTime = moment(
          //   `${datePart} ${brk.punch_in_time_str}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");
          // postform.append(
          //   `unpaid_breaks[${index}][clocked_in_datetime]`,
          //   inTime
          // );

          postform.append(
            `unpaid_breaks[${index}][clocked_in_datetime]`,
            brk.punch_in_time_str
          );
        });
      } else {
        postform.append("unpaid_breaks", []);
      }

      axios
        .post("/updatepayperiodreview", postform)
        .then((response) => {
          loader.hide();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$emit("reload-data");

          this.$refs.impaddtimessheetclose.click();

          this.resetAddForm();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    clickCloseModel() {
      this.resetAddForm();
    },
    resetAddForm() {
      this.addform = {
        user_id: "",
        designation_id: "",
        punch_in_time: "",
        punch_out_time: "",
        punch_from: "",
        list_breaks: { breaks: [] },
        list_unpaid_breaks: { breaks: [] },
      };
      this.clientError = [];

      // this.$refs.addTimeFormRef?.resetForm();
    },
    onUpdate() {
      console.log("update called");
      console.log(this.selectedtimesheet);

      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("user_id", this.selectedtimesheet.id);
      postform.append(
        "timesheet_date",
        moment(this.form.form_date).format("YYYY-MM-DD")
      );

      if (!this.form.punch_from == "") {
        postform.append("punch_from", this.form.punch_from);
      } else {
        this.clientError.push("edit_punch_from");
      }

      if (this.clientError?.length) {
        loader.hide();
        return;
      }
      if (this.form.punch_in_time != "") {
        // const datePart = moment(this.form.form_date).format("YYYY-MM-DD"); // → "2025-06-25"
        // const timePart = this.form.punch_in_time;
        // const fullDateTime = moment(
        //   `${datePart} ${timePart}`,
        //   "YYYY-MM-DD HH:mm"
        // ).format("YYYY-MM-DD HH:mm:ss");
        // postform.append("clocked_in", fullDateTime);

        postform.append("clocked_in", this.form.punch_in_time);
      } else {
        postform.append("clocked_in", "");
      }

      if (this.form.punch_out_time != "") {
        //   const datePart = moment(this.form.form_date).format("YYYY-MM-DD"); // → "2025-06-25"
        //   const timePart2 = this.form.punch_out_time;
        //   const fullDateTime2 = moment(
        //     `${datePart} ${timePart2}`,
        //     "YYYY-MM-DD HH:mm"
        //   ).format("YYYY-MM-DD HH:mm:ss");
        //   postform.append("clocked_out", fullDateTime2);

        postform.append("clocked_out", this.form.punch_out_time);
      } else {
        postform.append("clocked_out", "");
      }

      if (this.selectedtimesheet?.list_breaks?.paid_breaks?.length) {
        this.selectedtimesheet.list_breaks.paid_breaks.forEach((brk, index) => {
          //console.log(brk);

          // var bdatePart = moment(this.form.form_date).format("YYYY-MM-DD"); // → "2025-06-25"
          // var btimePart = brk.punch_out_time_str;
          // var bfullDateTime = moment(
          //   `${bdatePart} ${btimePart}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");
          // postform.append(
          //   `paid_breaks[${index}][clocked_out_datetime]`,
          //   bfullDateTime
          // );

          postform.append(
            `paid_breaks[${index}][clocked_out_datetime]`,
            brk.punch_out_time_str
          );

          // var btimePart2 = brk.punch_in_time_str;
          // var bfullDateTime2 = moment(
          //   `${bdatePart} ${btimePart2}`,
          //   "YYYY-MM-DD HH:mm"
          // ).format("YYYY-MM-DD HH:mm:ss");
          // postform.append(
          //   `paid_breaks[${index}][clocked_in_datetime]`,
          //   bfullDateTime2
          // );

          postform.append(
            `paid_breaks[${index}][clocked_in_datetime]`,
            brk.punch_in_time_str
          );
        });
      } else {
        postform.append("paid_breaks", []);
      }

      if (this.selectedtimesheet?.list_breaks?.unpaid_breaks?.length) {
        this.selectedtimesheet.list_breaks.unpaid_breaks.forEach(
          (brk, index) => {
            //console.log(brk);

            // var bdatePart = moment(this.form.form_date).format("YYYY-MM-DD"); // → "2025-06-25"
            // var btimePart = brk.punch_out_time_str;
            // var bfullDateTime = moment(
            //   `${bdatePart} ${btimePart}`,
            //   "YYYY-MM-DD HH:mm"
            // ).format("YYYY-MM-DD HH:mm:ss");
            // postform.append(
            //   `unpaid_breaks[${index}][clocked_out_datetime]`,
            //   bfullDateTime
            // );

            postform.append(
              `unpaid_breaks[${index}][clocked_out_datetime]`,
              brk.punch_out_time_str
            );

            // var btimePart2 = brk.punch_in_time_str;
            // var bfullDateTime2 = moment(
            //   `${bdatePart} ${btimePart2}`,
            //   "YYYY-MM-DD HH:mm"
            // ).format("YYYY-MM-DD HH:mm:ss");

            // postform.append(
            //   `unpaid_breaks[${index}][clocked_in_datetime]`,
            //   bfullDateTime2
            // );

            postform.append(
              `unpaid_breaks[${index}][clocked_in_datetime]`,
              brk.punch_in_time_str
            );
          }
        );
      } else {
        postform.append("unpaid_breaks", []);
      }

      postform.append("designation_id", this.form.selected_designation);

      axios
        .post("/updatepayperiodreview", postform)
        .then((response) => {
          loader.hide();
          this.$emit("reload-data");

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });

          this.$refs.imptimessheetclose.click();
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    deleteTimesheet(attendanceid) {
      var token = window.localStorage.getItem("token");

      axios.defaults.headers.common["Access-Control-Allow-Origin"] = "*";
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
      axios.defaults.headers.common["Content-Type"] = "multipart/form-data";

      let loader = this.$loading.show({
        // Optional parameters
        container: this.$refs.formContainer,
        canCancel: false,
      });

      var postform = new FormData();
      postform.append("employee_attendance_id", attendanceid);

      axios
        .post("/deletedailyreview", postform)
        .then((response) => {
          loader.hide();
          this.$emit("reload-data");

          this.$refs.imptimessheetclose.click();

          notification.open({
            message: response.data.message,
            placement: "topRight",
            duration: process.env.VUE_APP_NOTIFICATION_DURATION,
            style: {
              background: process.env.VUE_APP_SUCCESS_COLOR,
            },
          });
        })
        .catch((error) => {
          loader.hide();

          if (error.response) {
            var response = error.response;

            this.errors = response?.data?.error || null;

            notification.open({
              message: response.data.message,
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          } else {
            notification.open({
              message: "Server Error",
              placement: "topRight",
              duration: process.env.VUE_APP_NOTIFICATION_DURATION,
              style: {
                background: process.env.VUE_APP_WARNING_COLOR,
              },
            });
          }
        });
    },
    addNewBreak() {
      this.addform ??= {};
      this.addform.list_breaks ??= { breaks: [] };
      this.addform.list_breaks.breaks ??= [];

      this.addform.list_breaks.breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addBreak() {
      /*this.selectedtimesheet.dailyreport.list_breaks.breaks.push({
            punch_in_time_str: '',
            punch_out_time_str: ''
          });*/

      this.selectedtimesheet ??= {};
      console.log(this.selectedtimesheet);

      this.selectedtimesheet.list_breaks ??= { paid_breaks: [] };
      this.selectedtimesheet.list_breaks.paid_breaks ??= [];

      this.selectedtimesheet.list_breaks.paid_breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addUnpaidBreak() {
      this.selectedtimesheet ??= {};

      this.selectedtimesheet.list_breaks ??= { unpaid_breaks: [] };
      this.selectedtimesheet.list_breaks.unpaid_breaks ??= [];

      this.selectedtimesheet.list_breaks.unpaid_breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    addNewUnpaidBreak() {
      this.addform ??= {};
      this.addform.list_unpaid_breaks ??= { breaks: [] };
      this.addform.list_unpaid_breaks.breaks ??= [];

      this.addform.list_unpaid_breaks.breaks.push({
        punch_in_time_str: "",
        punch_out_time_str: "",
      });
    },
    removeUnpaidBreak(index) {
      this.selectedtimesheet.list_breaks.unpaid_breaks.splice(index, 1);
    },
    removeNewUnpaidBreak(index) {
      this.addform.list_unpaid_breaks.breaks.splice(index, 1);
    },
    removeNewBreak(index) {
      this.addform.list_breaks.breaks.splice(index, 1);
    },
    removeBreak(index) {
      this.selectedtimesheet.list_breaks.paid_breaks.splice(index, 1);
    },
    convertHoursToTimeFormat(hours) {
      if (hours == null || isNaN(hours)) return "0 hrs";

      const hrs = Math.floor(hours);
      const mins = Math.round((hours - hrs) * 60);

      const hrLabel = `${hrs} ${hrs === 1 ? "hr" : "hrs"}`;
      const minLabel = mins > 0 ? ` ${mins} min` : "";

      return hrLabel + minLabel;
    },
    formatTimeRange(startTime, endTime) {
      if (!startTime || !endTime) {
        return;
      }
      const start = this.parseTime(startTime);
      const end = this.parseTime(endTime);

      let startTotal = start.hours * 60 + start.minutes;
      let endTotal = end.hours * 60 + end.minutes;

      if (endTotal < startTotal) {
        endTotal += 24 * 60;
      }

      const durationMinutes = endTotal - startTotal;
      const hours = Math.floor(durationMinutes / 60);
      const minutes = durationMinutes % 60;

      return `${hours} hr ${minutes} min (${this.to12Hour(
        start
      )} - ${this.to12Hour(end)})`;
    },
    parseTime(timeStr) {
      console.log("time", timeStr);
      const [hours, minutes] = timeStr.split(":").map(Number);
      return { hours, minutes };
    },
    to12Hour({ hours, minutes }) {
      const period = hours >= 12 ? "pm" : "am";
      const hour12 = ((hours + 11) % 12) + 1;
      return `${hour12}:${minutes.toString().padStart(2, "0")} ${period}`;
    },
  },
  computed: {
    workedHours() {
      if (!this.form.punch_in_time || !this.form.punch_out_time) {
        return 0;
      }

      const inDate = new Date(this.form.punch_in_time);
      const outDate = new Date(this.form.punch_out_time);

      const diffMs = outDate - inDate; // millisecond difference
      const diffHrs = diffMs / (1000 * 60 * 60); // convert ms to hours

      return parseFloat(diffHrs.toFixed(2)); // rounded to 2 decimal places

      // const [inHours, inMinutes] = this.form.punch_in_time
      //   .split(":")
      //   .map(Number);
      // const [outHours, outMinutes] = this.form.punch_out_time
      //   .split(":")
      //   .map(Number);
      // const totalInMinutes = inHours * 60 + inMinutes;
      // const totalOutMinutes = outHours * 60 + outMinutes;

      // const diffMinutes = totalOutMinutes - totalInMinutes;
      // return diffMinutes / 60;
    },
    addWorkedHours() {
      if (!this.addform.punch_in_time || !this.addform.punch_out_time) {
        return 0;
      }
      const inDate = new Date(this.addform.punch_in_time);
      const outDate = new Date(this.addform.punch_out_time);

      const diffMs = outDate - inDate;
      const diffHrs = diffMs / (1000 * 60 * 60);

      return parseFloat(diffHrs.toFixed(2));
    },
  },
  watch: {
    UserId(newVal) {
      this.addform.user_id = newVal;
    },
    DesignationId(newVal) {
      this.addform.designation_id = newVal;
    },
    "form.punch_in_time": {
      handler() {
        this.workedHours;
      },
    },
    "form.punch_out_time": {
      handler() {
        this.workedHours;
      },
    },
    "addform.punch_in_time": {
      handler() {
        this.addWorkedHours;
      },
    },
    "addform.punch_out_time": {
      handler() {
        this.addWorkedHours;
      },
    },
    formErrors: {
      handler(newVal) {
        this.clientError = [];
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.loadAllEmployees();
    this.loadDesignations();

    // const addTimeCardModal = document.getElementById("add_timesheet");
    // if (addTimeCardModal) {
    //   addTimeCardModal.addEventListener("hidden.bs.modal", this.resetAddForm);
    // }
  },
  // setup() {
  //   const schema = Yup.object().shape({
  //     // user_id: Yup.string().required("Employee is required"),
  //     designation_id: Yup.string().required("Position is required"),
  //     punch_from: Yup.string().required("Punch form is required"),
  //   });

  //   return {
  //     schema,
  //   };
  // },
};
</script>
